import axios, { AxiosResponse } from "axios";
import "core-js/stable/atob";
import {jwtDecode} from "jwt-decode";
import {BackendUrl} from "../../util/config";

const API_URL = BackendUrl + '/auth';
interface AuthRequest {
    email: string;
    password: string;
}

// If you know the structure of your backend response, replace `any` with a proper interface
interface AuthResponse {
    // e.g., token: string;
    [key: string]: any;
}

interface DecodedToken {
    exp?: number; // 'exp' is in seconds
    // plus other JWT claims if needed
    sub: string;
    userId: string
}



export const register = async (
    email: string,
    password: string
): Promise<AxiosResponse<AuthResponse>> => {
    const payload: AuthRequest = { email, password };
    return axios.post(`${API_URL}/register`, payload);
};

export const login = async (
    email: string,
    password: string
): Promise<AxiosResponse<AuthResponse>> => {
    const payload: AuthRequest = { email, password };
    return axios.post(`${API_URL}/login`, payload);
};

export const saveToken = (token: string): void => {
    localStorage.setItem("jwt", token);
};


export const getToken = (): string | null => {
    const token = localStorage.getItem('jwt');
    if (!token) {
        return null; // No token in localStorage
    }

    // Decode token to check its expiration
    const decoded = jwtDecode<DecodedToken>(token);
    if (decoded.exp) {
        // 'exp' is typically a Unix timestamp (in seconds)
        const nowInSeconds = Date.now() / 1000;
        if (decoded.exp < nowInSeconds) {
            // Token is expired
            localStorage.removeItem('jwt');
            window.location.href = '/login';
            return null;
        }
    }

    // If we reach here, the token is not expired
    return token;
};

export const getUserIdFromToken = (): string | null => {
    const token = localStorage.getItem('jwt');
    if (!token) {
        return null; // No token in localStorage
    }

    // Decode token to check its expiration
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded.userId
}

export const removeToken = (): void => {
    localStorage.removeItem("jwt");
};

